import { Link } from 'react-router-dom';
import styles from './footer.module.scss';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`${styles.footer} footer py-1`}>
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <div className="text-dark fw-semibold fs-6">
          Voices {currentYear} © Todos los derechos reservados
        </div>
        <div className="text-dark fw-semibold fs-6">
          <Link to="/terms-conditions">
            <span className="underline-green text-primary fw-bolder">Términos y Condiciones</span>
          </Link>

          <span className="mx-2">-</span>

          <Link
            to="https://www.voices.com.mx/docs/apVoices2023.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="underline-green text-primary fw-bolder">Aviso de privacidad</span>
          </Link>
        </div>
      </div>
    </footer>
  );
}
